<template>
  <div>
    <div class="fillter_box row m-0 p-0">
      <div class="col-3 col-sm-5 p-0 pl-1 pr-1">
        <common-date-picker
          :label="''"
          :currentValue="dateStatus.currentValue"
          :currentOptions="dateStatus.dateOption"
          @input="v => {
                this.registrationDate.startDate = v.startDate,
                this.registrationDate.endDate = v.endDate,
                this.init()
              }"
        />
      </div>
      <button class="excel_down_btn excel_down_btn_ex shadow-none beta">이력다운로드</button>
    </div>
    <common-data-table
      hover
      :totalPage="totalPage"
      :curPage="curPage"
      class="col-12  p-0"
    >
      <template slot="header">
        <b-thead>
          <b-tr>
            <b-th>등록일자</b-th>
            <b-th>항목</b-th>
            <b-th>교환일시</b-th>
            <b-th>교환Km</b-th>
          </b-tr>
        </b-thead>
      </template>
      <template slot="body">
        <b-tbody>
          <b-tr v-for="(item, index) in items" :key="index">
            <b-td>{{ item.indate }}</b-td>
            <b-td>{{ item.name }}</b-td>
            <b-td>{{ item.date }}</b-td>
            <b-td>{{ item.last_km || 0 }}Km -> {{ item.km | comma }}Km</b-td>
          </b-tr>
        </b-tbody>
      </template>
    </common-data-table>
  </div>
</template>

<script>
import commonDataTable from '@/components/common/table/DataTable'
import commonDatePicker from '@/components/common/datepicker/DatePicker'
import ax from '@/api/parts'

export default {
  name: 'HistoryManage',
  components: {
    commonDataTable,
    commonDatePicker
  },
  data () {
    return {
      dateStatus: {
        currentValue: null,
        dateOption: [
          {
            text: '오늘',
            value: {
              startDate: this.$moment(new Date()).format('YYYYMMDD'),
              endDate: this.$moment(new Date()).format('YYYYMMDD')
            }
          },
          {
            text: '내일',
            value: {
              startDate: this.$moment(new Date()).add(1, 'day').format('YYYYMMDD'),
              endDate: this.$moment(new Date()).add(1, 'day').format('YYYYMMDD')
            }
          },
          {
            text: '이번달',
            value: {
              startDate: this.$moment(new Date()).format('YYYYMM01'),
              endDate: this.$moment(new Date()).endOf('month').format('YYYYMMDD')
            }
          }
        ],
      },
      registrationDate: {
        startDate: this.$moment(new Date()).format('YYYYMMDD'),
        endDate: this.$moment(new Date()).format('YYYYMMDD')
      },
      curPage: parseInt(this.$route.query.page) || 1,
      totalPage: 1,
      items: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      ax.partsForCar(this.$route.params.seq, this.registrationDate.startDate, this.registrationDate.endDate, this.curPage, data => {
        console.log(data)
        if (data) {
          this.items = data.items
          this.totalPage = data.totalPage
        } else {
          this.items = []
          this.totalPage = 1
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fillter_box {
  position: relative;
  height: 55px;
}

.excel_down_btn {
  position: absolute;
  top: 4px;
  right: 0px;
}
</style>
